import * as React from "react";
import {
  EVENT_INSTALLATION_CONSUMPTION_HISTORY_POINT_CONFIG_CHANGE,
  EVENT_INSTALLATION_CONSUMPTION_HISTORY_NORMALIZATION_CONFIG_CHANGE,
  EVENT_INSTALLATION_CONSUMPTION_HISTORY_FILTER_DATE_CHANGE,
  EVENT_EXPORT_PDF_CONSUMPTION_HISTORY,
  EVENT_EXPORT_EXCEL_CONSUMPTION_HISTORY,
} from "../../../Events";
import MaterialCustomSelectDate from "../../../features/SmartFilters/MaterialCustomSelectDate";
import { useHubx } from "../../../HubX";
import ButtonExport from "../../ButtonExport";
import ButtonSwitch from "../../ButtonSwitch";

function InstallationLevelConsumptionFilter() {
  const [pointConfig, setPointConfig] = React.useState(true);
  const [normalizationConfig, setNormalizationConfig] = React.useState(true);

  const hub = useHubx();

  const handleChangePointConfig = (newValue: boolean) => {
    setPointConfig(newValue);
    hub.notify(EVENT_INSTALLATION_CONSUMPTION_HISTORY_POINT_CONFIG_CHANGE, newValue);
  };

  const handleChangeNormalizationConfig = (newValue: boolean) => {
    setNormalizationConfig(newValue);
    hub.notify(EVENT_INSTALLATION_CONSUMPTION_HISTORY_NORMALIZATION_CONFIG_CHANGE, newValue);
  };

  const handleClickExportExcel = () => {
    hub.notify(EVENT_EXPORT_EXCEL_CONSUMPTION_HISTORY, true);
  };

  const handleClickExportPdf = () => {
    hub.notify(EVENT_EXPORT_PDF_CONSUMPTION_HISTORY, true);
  };

  return (
    <>
      <ButtonSwitch
        label="Pontos"
        onLabel="Slot"
        offLabel="Diário"
        onClick={handleChangePointConfig}
        value={pointConfig}
      />

      {/* <ButtonSwitch
        label="Dados Normalizados"
        onLabel="Sim"
        offLabel="Não"
        onClick={handleChangeNormalizationConfig}
        value={normalizationConfig}
      /> */}

      <ButtonExport
        label="Exportar"
        onClickExcel={handleClickExportExcel}
        onClickPdf={handleClickExportPdf}
      />

      <MaterialCustomSelectDate event={EVENT_INSTALLATION_CONSUMPTION_HISTORY_FILTER_DATE_CHANGE} />
    </>
  );
}

export default InstallationLevelConsumptionFilter;
